import { Box, styled, alpha } from '@mui/material';

export const TableContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    overflow: 'auto',
    border: 0,
    paddingBottom: '10px',
    boxSizing: 'content-box',
}));

export const TableHeader = styled(Box)(({ theme }) => ({
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 2,
    backgroundColor: theme.palette.background.default,
    backgroundImage: `linear-gradient(${alpha(theme.palette.text.primary, 0.08)}, ${alpha(theme.palette.text.primary, 0.08)})`,
    color: alpha(theme.palette.text.primary, 0.8),
    borderRadius: 1,
    display: 'flex',
    boxSizing: 'border-box',
}));

export const HeaderCell = styled(Box)(({ theme }) => ({
    padding: '0 4px',
    fontWeight: 400,
    fontSize: theme.typography.fontSize || 14,
    color: alpha(theme.palette.text.primary, 0.8),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    borderLeft: '4px solid transparent',
    borderRight: '4px solid transparent',
    borderTop: '4px solid transparent',
    borderBottom: '4px solid transparent',
    backgroundClip: 'padding-box',
    borderRadius: '6px',
    minHeight: '24px',
    lineHeight: '24px',
    position: 'relative',
    userSelect: 'none',
    cursor: 'default',
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: alpha(theme.palette.text.primary, 0.08),
        '.resize-handle': {
            opacity: 1,
        },
    },
}));

export const ResizeHandle = styled(Box)(({ theme }) => ({
    position: 'absolute',
    right: '-2px',
    top: '0',
    width: '8px',
    height: '100%',
    cursor: 'col-resize',
    zIndex: 10,
    userSelect: 'none',
    opacity: 0,
    transition: 'opacity 0.2s ease',
    backgroundColor: alpha(theme.palette.text.primary, 0.3),
    borderRadius: '2px',
    '&:hover': {
        opacity: 1,
        backgroundColor: alpha(theme.palette.primary.main, 0.6),
    },
    '&.resizing': {
        opacity: 0,
    },
}));

export const ResizeSpanner = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '5px',
    bottom: 0,
    width: '2px',
    backgroundColor: alpha(theme.palette.primary.main, 0.5),
    zIndex: 100,
    pointerEvents: 'none',
    display: 'none',
    '&.active': {
        display: 'block',
    },
}));

export const TableBody = styled(Box)({
    position: 'relative',
    paddingBottom: '10px',
    boxSizing: 'border-box',
});

export const Row = styled(Box)(({ theme }) => ({
    display: 'flex',
    position: 'absolute',
    left: 0,
    right: 0,
    backgroundColor: theme.palette.background.default,
    boxSizing: 'border-box',
    borderBottom: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
    '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
}));

export const Cell = styled(Box)(({ theme }) => ({
    padding: '0 8px',
    fontSize: theme.typography.fontSize || 14,
    fontWeight: theme.typography.fontWeightRegular || 400,
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    border: 'none',
}));

export const CellContent = styled(Box)(() => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    minWidth: 0,
    display: 'inline-block',
    verticalAlign: 'top',
}));

export const CopyableCell = styled(Box)(() => ({
    width: '100%',
    minWidth: 0,
    overflow: 'hidden',
    display: 'block',
    cursor: 'copy',
}));
